import React from 'react'
import NotiHeaderIcon from 'src/assets/img/chicken-noti.png'
import Danger from 'src/assets/img/menu/expiry_status/danger.png'
import Warning from 'src/assets/img/menu/expiry_status/warning.png'
import Safe from 'src/assets/img/menu/expiry_status/safe.png'

const SubmenuHeaderItem = () => {
  return (
    <div className="flex items-end">
      <img className="h-[74px] -mr-2" src={NotiHeaderIcon} alt="notification" />
      <div className="text-candy-pink font-bold text-[6.5px] leading-none z-10">
        <ul>
          消費期限に気を付けるコケ！
          <li className="flex items-center mt-2">
            <img className="w-3" src={Safe} alt="safe" /> 消費日期限残り10日
          </li>
          <li className="flex items-center">
            <img className="w-3" src={Warning} alt="warning" />
            消費日期限残り5日
          </li>
          <li className="flex items-center">
            <img className="w-3" src={Danger} alt="danger" />
            消費日期限残り1日
          </li>
        </ul>
      </div>
    </div>
  )
}

export default SubmenuHeaderItem
